module.exports = __webpack_public_path__ + "static/media/typeb2.264a8ab8.jpg";